import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import { toLine, formatRGBA, getformatstruct, getformitemsdata, getformListItemsdatas, bd_decrypt, getPointsBetweenLatLong } from '@/utils/utils';
import { mapState, mapGetters, mapMutations } from 'vuex';
import mapv2assembly from '@/view/map/customv2/dsmap';
import mappopupv2 from '@/view/map/customv2/dspop';
import typev2 from '@/components/mapv2/typev2/index';
import pointlistv2 from '@/view/map/hdmconfigv2/pointlist';
import axios from 'axios';
import { BMapLoader } from '@/utils/bdMap.js';
import cdata from '@/view/map/hdmconfigv2/common.js';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import routelist from '@/view/map/customv2/dsroutelist';
export default {
  name: 'dsapp',
  components: {
    mapv2assembly,
    mappopupv2,
    typev2,
    pointlistv2,
    routelist
  },
  props: {
    // 0配置页 1展示页
    id: {
      type: Number,
      default: 1
    },
    mapform: {
      type: Object,
      default: {}
    },
    style: {
      type: Object,
      default: {}
    },
    typelist: {
      type: Array,
      default: []
    },
    isloadingmap: {
      type: Boolean,
      default: false
    },
    maplayer: {
      type: Object,
      default: {}
    },
    viewInfo: {
      type: Object,
      default: {}
    },
    streetcode: {
      type: String,
      default: ''
    },
    mappointList: {
      type: Array,
      default: []
    },
    culturalList: {
      type: Array,
      default: []
    },
    maptemplate: {
      type: Number,
      default: 0
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    routelist: {
      type: Array,
      default: []
    },
    rtypelist: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      isMobileflag: false,
      // 移动端判断
      query: '',
      formUserId: '',
      // 最外层样式
      mainStyle: {
        width: '',
        height: '',
        transform: 'scale(1)',
        transformOrigin: '0 0',
        position: 'relative'
      },
      // 除地图以外的数据集合
      mapelem: {
        bg: '',
        logo: '',
        pickey: '',
        golist: 'https://p.ananas.chaoxing.com/star3/origin/3df243657b8ae7d4bd4eccd3446f3639.png'
      },
      // 除地图以外的样式集合
      modulestyle: {
        logo: '',
        pickey: '',
        type: '',
        list: ''
      },
      cTemplateScore: 0,
      popmodeltype: 0,
      // 弹窗默认模板样式
      pointdetail: {},
      popshowflag: false,
      showtype: 1,
      modeltype: 0,
      showlist: 1,
      typebtn: [],
      showgolist: false,
      showgolistId: 0,
      cform: {},
      // 非遗项目表单数据
      cformlabel: {},
      // 非遗项目表单结构标题集合
      cformoption: {},
      // 非遗项目表单结构默认选择项值集合
      cformfield: {},
      // 非遗项目表单校验集合
      cstructList: [],
      // 非遗项目表单结构数据
      cpList: [],
      // 添加或编辑非遗项目表单数据时列表
      defaultcform: {},
      // 非遗项目默认form数据
      cformUser: {},
      // 地图配置当前行ID数据
      formatData: {},
      // 地图配置当前行ID 格式化数据
      sList: [],
      // 添加或编辑地图表单数据时列表
      form: {},
      // 地图表单数据
      formlabel: {},
      // 地图表单结构标题集合
      formoption: {},
      // 地图表单结构默认选择项值集合
      formfield: {},
      // 地图表单校验集合
      mapview: {},
      loadingmap: false,
      mapLayers: {},
      mapstyle: {},
      jsonOption: {},
      typeList: [],
      // 分类列表数据
      mapstreetcode: '',
      typeform: {
        formId: '260297',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 分类列表查询字段
      pointform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 点位查询字段集合
      // 搜索定位点字段
      searchStr: {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '40',
            'compt': 'editinput',
            'express': '===',
            'val': ''
          }]
        }, {
          "model": 1,
          "filters": []
        }]
      },
      coordinate: '',
      // 当前点击经纬度
      pointList: [],
      // 点位列表数据
      mapculturalList: [],
      // 非遗项目列表数据
      maprouteList: [],
      // 路线列表数据
      mapcontainer: '',
      routeform: {
        formId: '1626576',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '8cb8793ff32dba9935520c2f7473a33e83825a93035ae6268d91df56c28f60d9',
        orderType: 'asc'
      },
      // 路线查询字段集合
      routePop: false,
      bdmaploaction: {},
      rtypeform: {
        formId: '1626580',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '7e324a759ba7eeb834922850eb694d88cedc5ae94849013a92bd11cd2b9784dd'
      },
      // 路线分类列表查询字段
      rtypeList: [],
      // 路线分类列表数据
      mapTimer: null,
      routeAllSource: [],
      routeAllLen: 0,
      switchScreenFlag: true,
      // 移动端切换屏幕标志
      routePoint: [],
      routePointList: [],
      cType: '',
      imgrotateflag: true,
      currentZoom: 0,
      views: 0,
      bgaudio: '',
      playflag: true,
      shareflag: false
    };
  },
  computed: {
    ...mapGetters(['mapv2info'])
  },
  watch: {
    mapform: {
      handler(val) {
        if (val) {
          this.form = val;
          this.mapformHandle(val);
        }
      },
      deep: true
    },
    style: {
      handler(val) {
        if (val) {
          // console.log(`supermapstyle`, val);
          this.mapstyle = val;
          this.styleHandle(val);
        }
      },
      deep: true
    },
    'style.typebtn': {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    'style.popcolor'(val) {
      if (val) this.popcolorFormat(val);
    },
    'style.typeall': {
      handler(val) {
        // console.log(`style.typeall`, val)
        this.mapstyle.typeall = val;
      },
      deep: true
    },
    'style.typeallname': {
      handler(val) {
        // console.log(`style.typeallname`, val)
        this.mapstyle.typeallname = val;
      },
      deep: true
    },
    viewInfo: {
      handler(val) {
        this.mapview = val;
      },
      deep: true
    },
    isloadingmap(val) {
      this.loadingmap = val;
    },
    maplayer: {
      handler(val) {
        this.mapLayers = val;
      },
      deep: true
    },
    typelist: {
      handler(val) {
        this.typeList = val;
      },
      deep: true
    },
    mappointList: {
      handler(val) {
        // console.log(`mappointList`, val);
        this.pointList = val;
      },
      deep: true
    },
    culturalList: {
      handler(val) {
        this.mapculturalList = val;
      },
      deep: true
    },
    maptemplate(val) {
      this.cTemplateScore = val;
    },
    streetcode(val) {
      this.mapstreetcode = val;
    },
    isMobile(val) {
      this.isMobileflag = val;
      this.changeMobile(val);
    },
    routelist: {
      handler(val) {
        this.maprouteList = val;
        this.routeHandle(this.maprouteList);
      },
      deep: true
    },
    rtypelist: {
      handler(val) {
        this.rtypeList = val;
      },
      deep: true
    },
    'mapv2info.style.typebtn': {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    'mapv2info.style': {
      handler(val) {
        // console.log(`this.mapv2info.style`, this.mapv2info.style)
        if (val) this.styleHandle(val);
      },
      deep: true
    },
    'mapv2info.style.popcolor'(val) {
      if (val) this.popcolorFormat(val);
    },
    'mapv2info.style.typeall': {
      handler(val) {
        this.mapstyle.typeall = val;
      },
      deep: true
    },
    'mapv2info.style.typeallname': {
      handler(val) {
        this.mapstyle.typeallname = val;
      },
      deep: true
    },
    'mapv2info.style.routebutton': {
      handler(val) {
        this.mapstyle.routebutton = val;
      },
      deep: true
    },
    'mapv2info.style.routebuttontext': {
      handler(val) {
        this.mapstyle.routebuttontext = val;
      },
      deep: true
    },
    'mapv2info.style.routepos': {
      handler(val) {
        this.mapstyle.routepos = val;
      },
      deep: true
    },
    'mapv2info.style.routebtn': {
      handler(val) {
        this.mapstyle.routebtn = val;
      },
      deep: true
    }
  },
  created() {
    this.mapconStyle();
  },
  mounted() {
    document.querySelector('html').style.height = '100%';
    document.querySelector('body').style.height = '100%';
    document.querySelector('#app').style.height = '100%';
    this.query = this.$route.query;
    this.formUserId = this.query.formUserId;
    console.log(`this.id`, this.id);
    if (this.query.fid === '166970') {
      this.judgeOrientation();
      window.addEventListener('orientationchange', this.judgeOrientation);
    }
    this.$nextTick(() => {
      this.loadBmap();
    });
  },
  methods: {
    ...mapMutations(['SET_MAPSENIOR', 'SET_MAPVIEW', 'SET_MAPFORM', 'SET_MAPFORMITEM', 'SET_MAPSTYLEITEM', 'SET_MAPDRAWLAYER', 'SET_COORDINATE', 'SET_MAPROUTESOURCE']),
    judgeOrientation() {
      if (window.orientation === 180 || window.orientation === 0) {
        // 竖屏状态！
        console.log(`// 竖屏状态！`);
        this.switchScreenFlag = true;
        this.mapview.rotation = 1.58;
        this.imgrotateflag = true;
        this.setScreenStyle();
      }
      if (window.orientation === 90 || window.orientation === -90) {
        // 横屏状态！
        console.log(`// 横屏状态！`);
        this.switchScreenFlag = false;
        this.mapview.rotation = 0;
        this.imgrotateflag = false;
      }
      this.setContainerWH();
      this.getMapData();
    },
    setScreenStyle() {
      let width = document.body.clientWidth;
      let height = document.body.clientHeight;
      const bgdiv = document.querySelector('.bg');
      bgdiv.style.width = height + 'px';
      bgdiv.style.height = width + 'px';
      bgdiv.style.transform = `rotate(90deg) translate(${(height - width) / 2}px, ${(height - width) / 2}px)`;
    },
    setContainerWH() {
      let width = window.screen.width;
      let height = window.screen.height;
      this.mainStyle.width = width + 'px';
      this.mainStyle.height = height + 'px';
    },
    loadBmap() {
      BMapLoader().then(BMap => {
        this.mapTimer = setInterval(() => {
          if (window.BMapGL && window.BMapGL.Map && window.BMapGL.Point) {
            this.mapcontainer = new BMap.Map('bdmap');
            let geolocation = new BMap.Geolocation();
            geolocation.getCurrentPosition(a => {
              console.log(a);
              this.bdmaploaction.address = a.address;
              this.bdmaploaction.lng = a.point.lng;
              this.bdmaploaction.lat = a.point.lat;
              localStorage.setItem('bdlocation', JSON.stringify(this.bdmaploaction));
            });
            clearInterval(this.mapTimer);
            this.mapTimer = null;
          }
        }, 100);
      });
    },
    mapconStyle() {
      this.mainStyle.width = `${window.innerWidth}px`;
      this.mainStyle.height = `${window.innerHeight}px`;
      if (window.innerWidth < 1081) this.isMobileflag = true;
    },
    percentageChange(scale) {
      this.mainStyle.transform = `scale(${scale})`;
    },
    /**
    * 定位点格式化
    */
    posFormat(val) {
      delete val.ptype;
      delete val.pIndex;
      return val;
    },
    popcolorFormat(val) {
      let obj = formatRGBA(val);
      let theme1 = `rgba(${obj.r},${obj.g},${obj.b},1)`;
      let theme2 = `rgba(${obj.r},${obj.g},${obj.b},0.7)`;
      document.documentElement.style.setProperty('--hand-drawn-pop-colortheme1', theme1);
      document.documentElement.style.setProperty('--hand-drawn-pop-colortheme07', theme2);
    },
    styleHandle(val) {
      // console.log(`styleHandle`, val)
      this.popmodeltype = val.popStyleIndex === undefined ? this.form.cTemplateScore === 1 ? 1 : 0 : val.popStyleIndex;
      this.modeltype = val.typeStyleIndex === undefined ? 0 : val.typeStyleIndex;
      Object.keys(this.modulestyle).forEach(key => {
        let pos = this.posFormat(val[`${key}pos`] !== undefined ? {
          ...val[`${key}pos`]
        } : {
          ...this.mapv2info.style[`${key}pos`]
        });
        let appPos = {};
        Object.keys(pos).forEach(item => {
          appPos[item] = this.isMobileflag ? `${parseFloat((parseInt(pos[item]) / 2 / 37.5).toFixed(6))}rem` : `${parseFloat((parseInt(pos[item]) / 1920 * 100).toFixed(6))}vw`;
        });
        this.modulestyle[key] = appPos;
      });
      if (val.typedisplay) this.modulestyle.type = Object.assign({}, this.modulestyle.type, val.typedisplay);
      // console.log(`this.modulestyle`, this.modulestyle)
    },
    mapformHandle(val) {
      this.mapelem.bg = val.background_img && val.background_img.length > 0 ? this.getImg(val.background_img[0]) : '';
      this.mapelem.logo = val.logo && val.logo.length > 0 ? this.getImg(val.logo[0]) : '';
      this.mapelem.pickey = val.pickey && val.pickey.length > 0 ? this.getImg(val.pickey[0]) : '';
      this.showtype = val.showtype;
      this.showlist = val.showlist;
      // this.isHasallarea(val)
      if (val.cTemplateScore === 1) this.getCulturalFormStruct();
    },
    changeMobile(val) {
      this.mapformHandle(this.form);
      if (val) {
        this.mainStyle.width = '375px';
        this.mainStyle.height = '667px';
      } else {
        this.mainStyle.width = `${window.innerWidth}px`;
        this.mainStyle.height = `${window.innerHeight}px`;
      }
    },
    markermoveend(val) {
      console.log(`val`, val);
      console.log(`this.cType`, this.cType);
      console.log(`this.mapview.zoom`, this.mapview.zoom);
      this.currentZoom = val;
      if (this.id === 1) {
        if (val === 9) return;
        // 点击单个路线时 禁止缩放更新数据
        if (this.routePoint.length > 0) return;
        this.popshowflag = false;
        this.removeAlliconsource();
        let zoom = val;
        if ((this.cType.index === 0 || this.cType === '') && val === 10) zoom = val + 1;
        if (this.cType !== '' && this.cType.index !== 0 && val - 10.6 < 2) zoom = val + 1;
        let minZoom = 10;
        let orData = [];
        for (let i = minZoom; i <= zoom; i++) {
          orData.push({
            'alias': 'map_level',
            'compt': 'editinput',
            'express': '===',
            'val': i
          });
        }
        this.searchStr.filters.forEach(item => {
          if (item.model === 1) item.filters = orData;
        });
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        this.pointform.page = 1;
        this.pointList = [];
        this.getpointData();
      } else {
        this.$emit('markermoveend', val);
      }
    },
    singleclick(val) {
      this.SET_COORDINATE(val);
    },
    /**
    * 定位点击操作
    * @param {Object} feature 选中数据
    */
    markerclick(feature) {
      this.pointdetail = {};
      this.popshowflag = false;
      this.$refs.pointpop.reset();
      if (feature === undefined) return;
      // 判断feature类型
      let gtype = feature.getGeometry().getType();
      // point显示弹窗详情
      if (gtype === 'Point') {
        let id = feature.get('id');
        let score = feature.get('score');
        let currentInfo = '';
        if (this.routePoint.length > 0) {
          if (this.routePointList.length > 0) currentInfo = this.routePointList.find(item => {
            return item.id === id;
          });
        } else {
          if (this.pointList.length > 0) currentInfo = this.pointList.find(item => {
            return item.id === id;
          });
        }
        if (currentInfo === undefined) return;
        // 标准模版获取弹窗
        if (score === 0) this.standardDetail(currentInfo);
      }
      // 总地图点击进入分地图
      if (gtype === 'Polygon' && this.form.ishaschild === '是' && this.id === 1) {
        let code = feature.get('code');
        let that = this;
        let mapform = {
          deptId: this.query.fid,
          formId: '177623',
          page: 1,
          limit: 100,
          searchStr: {
            model: 0,
            filters: [{
              "model": 0,
              "filters": [{
                'alias': '50',
                'compt': 'editinput',
                'express': 'like',
                'val': code
              }]
            }]
          }
        };
        mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
        this.$api.singleadvanceSearch(mapform).then(res => {
          if (res.totalRow > 0) {
            let cquery = location.hash.split('?')[1];
            let cparams = cquery.split('&');
            cparams = cparams.map(item => {
              let itemarr = item.split('=');
              if (itemarr[0] === 'formUserId') {
                itemarr[1] = res.dataList[0].id;
                item = itemarr.join('=');
              }
              return item;
            });
            window.location.href = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams.join('&');
          }
        });
      }
      // LineString路线点击显示详情
      if (gtype === 'LineString' && feature.get('type') === 'allroute') {
        let id = feature.get('id');
        let routeItem = this.maprouteList.find(item => {
          return item.id === id;
        });
        if (routeItem !== undefined) {
          this.routePop = true;
          this.routeDetail = routeItem;
        }
      }
      if (gtype === 'Point' && feature.get('type') === 'location') {
        ElMessage({
          message: '【仅用户在地图所选区域内生效】',
          type: 'warning'
        });
      }
    },
    /**
    * 标准模版获取点位详情
    * @param {Object} feature 选中数据
    */
    standardDetail(currentInfo) {
      let formatinfo = {};
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      formatinfo.audio = formatinfo.audio.length > 0 ? formatinfo.audio.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, '');
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : '';
      formatinfo.video = formatinfo.video.length > 0 ? formatinfo.video.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, '');
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : '';
      console.log(`formatinfo.video`, formatinfo.video);
      if (formatinfo['42'] === '弹窗') {
        this.pointdetail = formatinfo;
        this.popshowflag = true;
      }
      if (formatinfo['42'] === '链接' && formatinfo['44'] !== '') {
        let url = formatinfo['44'];
        if (formatinfo['44'].includes('superMapv2')) {
          let cparams = formatinfo['44'].split('?')[1];
          url = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams;
        }
        window.open(url);
      }
    },
    /**
    * 非遗模版获取点位详情
    * @param {Object} feature 选中数据
    */
    culturalDetail(currentInfo, feature) {
      let formatinfo = {};
      let coordinate = feature.xy ? feature.xy : feature.get('xy');
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      formatinfo.coordinate = coordinate;
      formatinfo.gateway = formatinfo.gateway = formatinfo.detailUrl !== '' ? `${formatinfo.detailUrl}&mapid=${formatinfo.number}` : '';
      this.pointdetail = formatinfo;
      this.popshowflag = true;
      if (this.popmodeltype === 1 && !this.isMobileflag) {
        this.$nextTick(() => {
          this.$refs.mapv2assembly.addpopOverLay(coordinate);
        });
      }
    },
    /**
    * 弹窗关闭事件
    */
    closeHandle() {
      this.popshowflag = false;
      this.pointdetail = {};
      if (!this.isMobileflag) document.querySelector('.map_content').style.zIndex = 2;
    },
    /**
    * 分类选择事件
    */
    typeselect(val) {
      if (this.id === 1) {
        this.typeClick(val);
      } else {
        this.$emit('typeselect', val);
      }
    },
    /**
     * 分类数据格式化
     */
    typebtnFormat(val) {
      let typebtn = [...val];
      this.typebtn = [];
      typebtn.forEach(elem => {
        let item = {
          ...elem
        };
        if (item.imgList && item.imgList.length > 0) {
          item.backgroundImage = 'url(\'' + this.getImg(item.imgList[0]) + '\')';
          item.backgroundSize = '100% 100%';
          item.backgroundRepeat = 'no-repeat';
        }
        item.textAlign = 'center';
        delete item.imgList;
        let newitem = {};
        Object.keys(item).forEach(child => {
          if (this.isMobileflag) {
            newitem[child] = /px$/.test(item[child]) ? `${parseFloat((parseInt(item[child]) / 2 / 37.5).toFixed(6))}rem` : item[child];
          } else {
            newitem[child] = /px$/.test(item[child]) ? `${parseFloat((parseInt(item[child]) / 1920 * 100).toFixed(6))}vw` : item[child];
          }
        });
        this.typebtn.push(newitem);
      });
    },
    removeAlliconsource() {
      this.$refs.mapv2assembly.removeAlliconsource();
    },
    saveDrawHandle() {
      this.$refs.mapv2assembly.saveDrawHandle();
    },
    updateMap() {
      this.$refs.mapv2assembly.updateMap();
    },
    removeDrawsource() {
      this.$refs.mapv2assembly.removeDrawsource();
    },
    removeRoutesource() {
      this.$refs.mapv2assembly.removeRoutesource();
    },
    isHasallarea(val) {
      let that = this;
      let mapform = {
        deptId: this.query.fid,
        formId: '177623',
        page: 1,
        limit: 100,
        searchStr: {
          model: 0,
          filters: [{
            "model": 0,
            "filters": [{
              'alias': 'ishaschild',
              'compt': 'radiobutton',
              'express': '===',
              'val': ['是']
            }]
          }]
        }
      };
      mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
      this.$api.singleadvanceSearch(mapform).then(res => {
        if (res.totalRow > 0) {
          this.showgolist = val.ishaschild === '是' ? false : true;
          if (this.showgolist) this.showgolistId = res.dataList[0].id;
        }
      });
    },
    golist() {
      let cquery = location.hash.split('?')[1];
      let cparams = cquery.split('&');
      cparams = cparams.map(item => {
        let itemarr = item.split('=');
        if (itemarr[0] === 'formUserId') {
          itemarr[1] = this.showgolistId;
          item = itemarr.join('=');
        }
        return item;
      });
      window.location.href = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams.join('&');
    },
    /**
     * 获取非遗项目表单结构数据
     */
    getCulturalFormStruct() {
      let params = {
        deptId: this.query.fid,
        formId: 'cultural_heritage_project'
      };
      this.$api.formStruct(params).then(res => {
        this.cstructList = JSON.parse(JSON.stringify(res));
        this.cpList = getformatstruct(res, this.cform, this.cformlabel, this.cformfield, this.cformoption);
        this.defaultcform = Object.assign({}, this.cform);
      });
    },
    setComonStyle() {
      document.querySelector('html').style.fontSize = `${window.screen.width / 10}px`;
    },
    /**
     * 获取地图设置行
     */
    getMapData() {
      let that = this;
      this.$api.singleformUserId(this.query.fid, '177623', this.query.formUserId).then(res => {
        if (res.formUserList.length > 0) {
          that.cformUser = res.formUserList[0];
          let formatData = {};
          res.formUserList[0].formData.forEach(item => {
            formatData[item.alias] = getformitemsdata(item);
          });
          that.formatData = formatData;
          document.title = formatData.toptitle;
          that.views = Number(formatData.visits) + Number(formatData.customvisits);
          // 处理地图view相关字段
          that.getFormStruct();
          // 增加浏览量
          if (formatData.visits !== undefined) that.addVisits();
          // 获取背景音乐
          if (formatData.bgaudiofile.length > 0) that.getBgaudio(formatData.bgaudiofile);
        }
      });
    },
    /**
     * 获取地图配置表单结构
     */
    getFormStruct() {
      let params = {
        deptId: this.$route.query.fid,
        formId: 177623
      };
      this.$api.formStruct(params).then(res => {
        this.sList = getformatstruct(res, this.form, this.formlabel, this.formfield, this.formoption);
        this.mapview = this.mapv2info.view;
        this.editlogic(this.formatData);
        this.gettypeList();
      });
    },
    /**
     * 配置页编辑逻辑处理
     */
    editlogic(data) {
      this.mapLayers.tiles = true;
      this.mapLayers.json = true;
      this.mapLayers.static = true;
      Object.keys(data).forEach(item => {
        this.form[item] = data[item];
      });
      this.jsonOption = {
        ...JSON.parse(this.form.jsontxt.replace(/(<\/?p.*?>)/gi, ''))
      };
      if (this.jsonOption.screen && Object.keys(this.jsonOption.screen).length > 0) {
        let screenData = this.isMobileflag ? this.jsonOption.screen.app : this.jsonOption.screen.pc;
        Object.keys(screenData).forEach(item => {
          this.jsonOption[item] = screenData[item];
        });
      }
      console.log(`this.jsonOption`, this.jsonOption);
      this.mapviewhandle(this.jsonOption.view);
      this.form.showtype = this.jsonOption.style.showtype;
      this.form.showlist = this.jsonOption.style.showlist;
      this.form.scale = this.jsonOption.view.scale;
      this.form.rotate = this.jsonOption.view.rotate;
      this.form.typeall = this.jsonOption.style.typeall !== undefined ? this.jsonOption.style.typeall : true;
      this.form.typeallname = this.jsonOption.style.typeallname ? this.jsonOption.style.typeallname : '全部';
      this.form.showroute = this.jsonOption.style.showroute ? this.jsonOption.style.showroute : 1;
      this.SET_MAPFORM(this.form);
      this.SET_MAPVIEW(this.jsonOption.view);
      this.SET_MAPSENIOR(this.jsonOption.senior);
      this.SET_MAPSTYLEITEM({
        showtype: this.jsonOption.style.showtype
      });
      this.SET_MAPSTYLEITEM({
        showlist: this.jsonOption.style.showlist
      });
      this.SET_MAPSTYLEITEM({
        typeall: this.form.typeall
      });
      this.SET_MAPSTYLEITEM({
        typeallname: this.form.typeallname
      });
      this.SET_MAPSTYLEITEM({
        showroute: this.jsonOption.style.showroute
      });
      this.mapview = this.jsonOption.view;
      this.mapview.rotation = this.switchScreenFlag ? 1.58 : 0;
      this.mapview.zoom = 9.5;
      this.mapview.minZoom = 9;
      this.mapview.center = [109.92, 39.82];
      this.mapstyle = this.jsonOption.style;
      this.mapstyle.typeall = this.form.typeall;
      this.mapstyle.typeallname = this.form.typeallname;
      this.senior = this.jsonOption.senior;
      if (this.form.static_img && this.form.static_img.length > 0) {
        this.mapLayers.staticimage = this.getImg(this.form.static_img[0]);
        this.mapLayers.tiles = false;
      }
      // this.mapLayers.route = this.form.showroute === 1 ? true : false

      // 判断当前地图模版 score  0标准模版  1非遗模版
      this.formoption.mapTemplate.forEach(elem => {
        if (this.formatData.mapTemplate === elem.title) {
          this.cTemplateScore = elem.score;
          this.SET_MAPFORMITEM({
            cTemplateScore: elem.score
          });
        }
      });
      this.SET_MAPDRAWLAYER(this.jsonOption.drawlayer);
      this.mapLayers.drawelement = this.jsonOption.drawlayer;
      this.mapformHandle(this.form);
      this.$nextTick(() => {
        console.log(`this.jsonOption.style`, this.jsonOption.style);
        this.styleHandle(this.jsonOption.style);
        this.typebtnFormat(this.jsonOption.style.typebtn);
        this.popcolorFormat(this.jsonOption.style.popcolor);
      });
      // 是否含有乡镇街道
      if (this.jsonOption.geojson.adcode === undefined) this.mapstreetcode = this.jsonOption.geojson.code;
      let adcode = this.jsonOption.view.adcode;
      if (this.mapstreetcode !== undefined && this.mapstreetcode !== '') {
        axios.get(`${process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin}/frontendTest1/openlayers/data/${adcode}.json`).then(res => {
          if (res.status === 200) {
            let cjson = res.data.features.filter(item => {
              return Number(item.properties.code) === Number(this.mapstreetcode);
            });
            if (cjson.length > 0) {
              let datacoord = cjson[0].geometry.coordinates[0];
              let changedata = [];
              datacoord.forEach(elem => {
                changedata.push(transform(elem, 'EPSG:4326', 'EPSG:3857'));
              });
              cjson[0].geometry.coordinates[0] = changedata;
              this.mapLayers.geojson = {
                type: 'FeatureCollection',
                features: cjson
              };
              this.loadingmap = true;
            }
          }
        }).catch(error => {});
        return;
      }
      // 自定义json数据
      if (this.jsonOption.view.adcode === 'region') {
        let datacoord = this.jsonOption.geojson.features[0].geometry.coordinates[0];
        let changedata = [];
        datacoord.forEach(elem => {
          changedata.push(transform(elem, 'EPSG:4326', 'EPSG:3857'));
        });
        this.jsonOption.geojson.features[0].geometry.coordinates[0] = changedata;
        this.mapLayers.geojson = {
          type: 'FeatureCollection',
          features: this.jsonOption.geojson.features
        };
      }
      this.loadingmap = true;
    },
    mapviewhandle(view) {
      let center = view.center;
      this.form.centerX = center[0];
      this.form.centerY = center[1];
      this.form.minZoom = view.minZoom;
      this.form.maxZoom = view.maxZoom;
      this.form.zoom = view.zoom;
      this.form.static_map_min_level = view.minZoom;
      this.form.static_map_max_level = view.maxZoom;
      this.form.current_level = view.zoom;
      this.form.map_center = center.join(',');
      this.form.transform_extent = view.extent.join(',');
    },
    /**
     * 获取分类列表数据
     */
    gettypeList() {
      let that = this;
      this.typeform.deptId = this.query.fid;
      this.$api.singleadvanceSearch(this.typeform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          this.typeList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          this.typeList = res.dataList.sort((a, b) => Number(a.itemformdata.sortId) - Number(b.itemformdata.sortId));
          if (!this.mapstyle.typeall) {
            this.searchStr.filters.push({
              "model": 0,
              "filters": [{
                'alias': 'map_type2',
                'compt': 'editinput',
                'express': '===',
                'val': this.typeList[0].itemformdata.title
              }]
            });
          }
          // console.log(`typeList`, this.typeList)
        }

        // 处理地点管理表 请求参数
        this.pointform.deptId = this.query.fid;
        this.searchStr.filters[0].filters[0].val = this.formatData.title || this.formatData['46'];
        this.currentZoom = 10.6;
        let zoom = 10.6;
        let minZoom = 10;
        if (this.isMobileflag) zoom += 1;
        let orData = [];
        for (let i = minZoom; i <= zoom; i++) {
          orData.push({
            'alias': 'map_level',
            'compt': 'editinput',
            'express': '===',
            'val': i
          });
        }
        this.searchStr.filters.forEach(item => {
          if (item.model === 1) item.filters = orData;
        });
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        this.getpointData();
      });
    },
    /**
     * 获取地点管理表数据
     */
    getpointData(val) {
      let that = this;
      this.$api.singleadvanceSearch(this.pointform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.pointform.page === 1) that.pointList = [];
          let dataList = that.formdataformat(res);
          that.pointList = that.pointform.page === 1 ? dataList : that.pointList.concat(dataList);
          if (res.totalPage > 1) that.pointform.page++;
          if ((res.totalPage === 1 || res.totalPage === that.pointform.page) && val === undefined && that.rtypeList.length === 0) that.getroutetypeData();
          if (res.totalPage > 1 && res.totalPage >= that.pointform.page) that.getpointData();
        }
      });
    },
    /**
     * 点击类型操作
     * @param {Object} data 选中数据及索引 index item
     */
    typeClick(data) {
      console.log(`this.currentZoom`, this.currentZoom);
      console.log(`this.mapview.zoom`, this.mapview.zoom);
      this.cType = data;
      this.popshowflag = false;
      this.removeAlliconsource();
      let dindex = data.index;
      let val = dindex === 0 ? '' : !data.child ? data.item.itemformdata : data.child;
      let typesearchflag = false;
      if (dindex === 0) {
        this.searchStr.filters.forEach((item, index) => {
          if (item.filters.length > 0 && item.filters[0].alias === 'map_type2') this.searchStr.filters.splice(index, 1);
          if (item.model === 1) {
            let zoom = this.currentZoom <= 11 ? 11 : this.currentZoom;
            let minZoom = 10;
            let orData = [];
            for (let i = minZoom; i <= zoom; i++) {
              orData.push({
                'alias': 'map_level',
                'compt': 'editinput',
                'express': '===',
                'val': i
              });
            }
            item.filters = orData;
          }
        });
      } else {
        this.searchStr.filters.forEach(item => {
          if (item.filters.length > 0 && item.filters[0].alias === 'map_type2') {
            item.filters[0].val = val.title;
            typesearchflag = true;
          }
          if (item.model === 1) {
            let zoom = this.currentZoom <= 11 ? 11 : this.currentZoom;
            if (this.currentZoom - 10.6 < 2) zoom = Math.round((this.currentZoom < 11 ? 11 : this.currentZoom) + 1);
            console.log(`zoom`, zoom);
            let minZoom = 10;
            let orData = [];
            for (let i = minZoom; i <= zoom; i++) {
              orData.push({
                'alias': 'map_level',
                'compt': 'editinput',
                'express': '===',
                'val': i
              });
            }
            item.filters = orData;
          }
        });
        if (!typesearchflag) {
          this.searchStr.filters.push({
            "model": 0,
            "filters": [{
              'alias': 'map_type2',
              'compt': 'editinput',
              'express': 'like',
              'val': val.title
            }]
          });
        }
      }
      this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.pointform.page = 1;
      this.pointList = [];
      this.getpointData();
      // 点击非全部类型 隐藏路线列表
      this.$refs.routelist.routebtnHide();
      this.$refs.mapv2assembly.removeRoutesource();
    },
    pointlistClick(item) {
      this.$refs.pointlist.listDown();
      this.pointdetail = {};
      this.popshowflag = false;
      let citem = item.itemformdata;
      if (citem.correlation_address.length > 0) {
        let gd = bd_decrypt(Number(citem.correlation_address[0].lng), Number(citem.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        this.culturalDetail(item, {
          xy: [x, y]
        });
      }
    },
    listUp() {
      this.pointdetail = {};
      this.popshowflag = false;
    },
    formdataformat(res) {
      return res.dataList.map((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        return item;
      });
    },
    getroutetypeData() {
      let that = this;
      this.rtypeform.deptId = this.query.fid;
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'mapbelongId',
            'compt': 'editinput',
            'express': '===',
            'val': this.formatData.onlyid
          }]
        }]
      };
      this.rtypeform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(this.rtypeform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.rtypeform.page === 1) that.rtypeList = [];
          let dataList = that.formdataformat(res);
          let sortdataList = dataList.sort((a, b) => Number(a.itemformdata.sortId) - Number(b.itemformdata.sortId));
          that.rtypeList = that.routeform.page === 1 ? sortdataList : that.rtypeList.concat(sortdataList);
          if (res.totalPage > 1) that.rtypeform.page++;
          if ((res.totalPage === 1 || res.totalPage === that.rtypeform.page) && that.maprouteList.length === 0) that.getrouteData();
          if (res.totalPage > 1 && res.totalPage >= that.rtypeform.page) that.getroutetypeData();
        }
      });
    },
    /**
     * 获取路线管理表表单数据
     */
    getrouteData() {
      let that = this;
      this.routeform.deptId = this.query.fid;
      this.$api.singleadvanceSearchv2(this.routeform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.routeform.page === 1) that.maprouteList = [];
          let dataList = that.formdataformat(res);
          that.maprouteList = that.routeform.page === 1 ? dataList : that.maprouteList.concat(dataList);
          if (res.totalPage > 1) that.routeform.page++;
          // if (res.totalPage === 1 || res.totalPage === that.routeform.page) {
          //     if (that.cType === '') that.routeHandle(that.maprouteList)
          // }
          if (res.totalPage > 1 && res.totalPage >= that.routeform.page) that.getrouteData();
        }
      });
    },
    routeHandle(val) {
      this.routeAllLen = val.length;
      this.routeAllSource = [];
      val.forEach((elem, index) => {
        let routes = [];
        let routejson = {
          ...JSON.parse(elem.itemformdata.jsontxt.replace(/(<\/?p.*?>)/gi, ''))
        };
        // console.log(`routejson`, routejson)
        for (let i = 0; i < routejson.routedata.length - 1; i++) {
          let start = routejson.routedata[i].coordinate;
          let end = routejson.routedata[i + 1].coordinate;
          let tStart = bd_decrypt(start[0], start[1]);
          let tEnd = bd_decrypt(end[0], end[1]);
          let transStart = transform([tStart.lng, tStart.lat], 'EPSG:4326', 'EPSG:3857');
          let transEnd = transform([tEnd.lng, tEnd.lat], 'EPSG:4326', 'EPSG:3857');
          let pathitem = [];
          pathitem = getPointsBetweenLatLong(transStart[1], transStart[0], transEnd[1], transEnd[0], 10);
          pathitem.unshift(transStart);
          pathitem.push(transEnd);
          routes.push(pathitem);
        }
        this.routeAllSource.push({
          path: routes,
          style: routejson.style,
          id: elem.id
        });
      });
      if (this.routeAllSource.length === this.routeAllLen) this.SET_MAPROUTESOURCE(this.routeAllSource);
    },
    routeChange(val) {
      console.log(`routeChange`, val);
      this.$refs.mapv2assembly.removeRoutesource();
      if (val.length === 0) {
        this.routePoint = [];
        this.$refs.routelist.routebtnHide();
        this.typeClick(this.cType === '' ? {
          index: 0,
          item: ''
        } : this.cType);
        return;
      }
      this.routePointList = val.data;
      this.mapLayers.route = true;
      this.getsingleroute(val);
    },
    getsingleroute(val) {
      let routePoint = [];
      val.cItem.forEach(elem => {
        let routejson = {
          ...JSON.parse(elem.itemformdata.jsontxt.replace(/(<\/?p.*?>)/gi, ''))
        };
        routejson.routedata.forEach(item => {
          let route = val.data.find(point => {
            return point.id === item.id;
          });
          if (route !== undefined) routePoint.push(route);
        });
      });
      this.routePoint = routePoint;
      this.routeHandle(val.cItem);
    },
    switchScreen() {
      let cparams = [];
      Object.keys(this.query).forEach(elem => {
        cparams.push(`${elem}=${this.query[elem]}`);
      });
      if (!cparams.includes('show=true')) cparams.push('show=true');
      window.location.replace(location.protocol + '//' + location.host + location.pathname + '?page=dspc?' + cparams.join('&'));
    },
    routeshow(val) {
      this.mapLayers.route = val;
    },
    formatIntroduce(val) {
      return val.replace(/\n/g, '<br>');
    },
    /**
     * 增加浏览量
     */
    addVisits() {
      let dataList = [];
      dataList.push({
        'alias': 'onlyid',
        'compt': 'autonumber',
        'values': [{
          'val': this.formatData.onlyid
        }]
      });
      dataList.push({
        'alias': 'title',
        'compt': 'editinput',
        'values': [{
          'val': this.formatData.title
        }]
      });
      dataList.push({
        'alias': 'visits',
        'compt': 'numberinput',
        'values': [{
          'val': Number(this.formatData.visits) + 1
        }]
      });
      this.$api.editForm(this.query.fid, this.query.formUserId, encodeURI(JSON.stringify(dataList)), this.cformUser.formId).then(res => {});
    },
    audiobgHandle() {
      this.playflag = !this.playflag;
      if (!this.playflag) {
        this.$refs.bgaudio.pause();
      } else {
        this.$refs.bgaudio.play();
      }
    },
    getBgaudio(val) {
      this.$api.getUrlByObjectId(val[0].objectId).then(res => {
        this.bgaudio = res.http;
      });
    },
    getImg(val) {
      return val.fileUrl;
    }
  }
};